import React from "react";

const ManageCurrencies = () => {
  return (
    <div>
      <h2>List Currency</h2>
    </div>
  );
};

export default ManageCurrencies;
